import React from "react";
import ReactGA from "react-ga";
import DashNavBar from "./DashNavBar";

function App() {
  return (
    <div>
      <DashNavBar />
    </div>
  );
}

export default App;
